import RESOURCE_CATEGORIES from './resourceCategory';

const RESOURCE_CATEGORY_DISPLAY_NAMES = {
  [RESOURCE_CATEGORIES.GETTING_STARTED]: { name: 'Getting Started', value: 'getting-started' },
  [RESOURCE_CATEGORIES.APPRAISAL_VALUE]: { name: 'Appraisal Value', value: 'appraisal-value' },
  [RESOURCE_CATEGORIES.VIP_ENGAGEMENT]: {
    name: 'VIP Engagement',
    value: 'vip-engagement'
  }
};

export default RESOURCE_CATEGORY_DISPLAY_NAMES;
